import { AxiosInstance } from 'axios';
import { getWithAuth } from '../InitializeService';

export const getAnnouncements = (instance: AxiosInstance, login: string) => {
    return getWithAuth('mysite/announcements?loginname=' + login, instance);
}